export const GET_PROJECTS = 'GET_PROJECTS';
export const SET_PROJECTS_PAGINATION = 'SET_PROJECTS_PAGINATION';
export const SET_PROJECTS_FILTERS = 'SET_PROJECTS_FILTERS';
export const RESET_PROJECTS = 'RESET_PROJECTS';
export const TOGGLE_PROJECT = 'TOGGLE_PROJECT';
export const ADD_PROJECT = 'ADD_PROJECT';
export const UPDATE_PROJECT = 'UPDATE_PROJECT';
export const GET_PROJECT_BY_ID = 'GET_PROJECT_BY_ID';
export const RESET_PROJECT_FORM = 'RESET_PROJECT_FORM';
export const MODIFY_EDITING_PROJECT = 'MODIFY_EDITING_PROJECT';

//Groups
export const MODIFY_CUSTOM_FIELD_EDITING_PROJECT = 'MODIFY_CUSTOM_FIELD_EDITING_PROJECT';



// WEBPACK FOOTER //
// src/modules/secured/modules/projects/constants/projects_constants.js